import styled from "styled-components";

const Logo = styled.img`
  width: 180px;
`

export default Logo;